export const COMMENT_TYPES = {
  USER_COMMENT: 0,
  SYSTEMIC_COMMENT: 1
};
